import { render, staticRenderFns } from "./ReportTableProductionByShift.vue?vue&type=template&id=2b5f7137&"
import script from "./ReportTableProductionByShift.vue?vue&type=script&lang=js&"
export * from "./ReportTableProductionByShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports